// src/components/billing/VersionCompareDrawer.tsx
import { Drawer, Stack, Text } from "@mantine/core";
import type { FeePolicy } from "../../apis/tenantFeePolicy";
import { DiffViewer } from "./DiffViewer";

const POLICY_LABELS: Record<string, string> = {
  status: "Төлөв",
  calculationMethod: "Тооцоолох арга",
  feeRate: "Шимтгэлийн хувь",
  flatFeeAmount: "Тогтмол шимтгэл",
  minFeeAmount: "Хамгийн бага шимтгэл",
  maxFeeAmount: "Хамгийн их шимтгэл",
  feeBasis: "Тооцооллын суурь",
  deductionMode: "Суутгалын горим",
  refundPolicy: "Буцаалтын бодлого",
  feeCurrency: "Мөнгөн тэмдэгт",
  effectiveFrom: "Хүчин төгөлдөр болсон огноо",
  absorbPlatformFee: "Платформ шимтгэл хамгаалах",
};

function policyToRecord(policy: FeePolicy): Record<string, unknown> {
  return {
    status: policy.status,
    calculationMethod: policy.calculationMethod,
    feeRate: policy.feeRate ?? null,
    flatFeeAmount: policy.flatFeeAmount ?? null,
    minFeeAmount: policy.minFeeAmount ?? null,
    maxFeeAmount: policy.maxFeeAmount ?? null,
    feeBasis: policy.feeBasis,
    deductionMode: policy.deductionMode,
    refundPolicy: policy.refundPolicy,
    feeCurrency: policy.feeCurrency,
    effectiveFrom: policy.effectiveFrom ?? null,
    absorbPlatformFee: policy.absorbPlatformFee ?? false,
  };
}

interface Props {
  before: FeePolicy | null;
  after: FeePolicy | null;
  opened: boolean;
  onClose: () => void;
}

export function VersionCompareDrawer({ before, after, opened, onClose }: Props) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="lg"
      title="Хувилбарын зэрэгцүүлэлт"
    >
      {before && after ? (
        <Stack gap="md">
          <Text size="sm" c="dimmed">
            v{before.currentVersion} → v{after.currentVersion}
          </Text>
          <DiffViewer
            before={policyToRecord(before)}
            after={policyToRecord(after)}
            labels={POLICY_LABELS}
          />
        </Stack>
      ) : (
        <Text c="dimmed">Сонголт хийгдээгүй.</Text>
      )}
    </Drawer>
  );
}
